import { Users } from 'lucide-react';

export function About() {
  return (
    <section id="about" className="py-20 md:py-28">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image/Visual */}
          <div className="relative">
            <div className="aspect-[4/3] bg-sage-light rounded-2xl overflow-hidden flex items-center justify-center">
              <div className="text-center p-8">
                <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-sage flex items-center justify-center">
                  <Users className="w-12 h-12 text-accent-foreground" />
                </div>
                <h3 className="font-display text-2xl font-bold text-foreground mb-2">
                  Father & Son Team
                </h3>
                <p className="text-muted-foreground">
                  Proudly serving Phoenix since 1994
                </p>
              </div>
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-secondary rounded-2xl -z-10" />
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-sage/20 rounded-full -z-10" />
          </div>

          {/* Content */}
          <div>
            <span className="inline-block px-4 py-1.5 bg-sage-light text-sage rounded-full text-sm font-medium mb-4">
              About Us
            </span>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
              A Family Business Built on Trust
            </h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p>
                We are a proud father-and-son team running this family business with a 
                dedication to providing top-notch service to ensure that our customers 
                always get the best deal possible.
              </p>
              <p>
                Our mission is to deliver high-quality products with honesty and integrity, 
                doing fair business every step of the way. Based out of the West Valley, 
                we've been proudly serving Phoenix and surrounding areas for over 30 years.
              </p>
              <p>
                As a small business, we believe in treating our customers like family. We 
                offer personalized service that you won't find with larger companies, and 
                are committed to being fair and transparent.
              </p>
              <p className="font-medium text-foreground">
                When you work with us, you can trust that you'll receive professional care, 
                competitive prices, and a team that's invested in your satisfaction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
